import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { TextLarge } from '../../components/text';
import { RenderForm } from '../../components/forms';
import { FORM_LOGOUT_EMPLOYEE } from './form';
import { ContainerButton } from '../../styles/global-style';
import { ButtonTheme } from '../../components/buttons';
import { useForm } from 'react-hook-form';
import { StyledContainer } from '../../components/container/styles';
import { useLogoutEmployee } from './hooks/useLogoutEmployee';
import { ROUTES_PATH } from '../../resources/routes-name';
import { removeCookies } from '../../store/useCookies';
import { openAlert } from '../../components/alert/hooks';
import { Spin } from 'antd';
import { branchOptionQuery } from '../../services/react-query/optionMasterQuery';

export const LogoutEmployee = () => {
  const { control, setValue, getValues, handleSubmit, watch } = useForm();
  const { employeeId, lineUid, branchId } = useSelector((state) => state.info);
  const { mutate: onLogout, isPending: isPendingLogout } = useLogoutEmployee();
  const { data: branchOption } = branchOptionQuery(employeeId);

  const branchIdNew = watch('branchId');
  const prevBranchId = useRef();

  useEffect(() => {
    if (prevBranchId.current !== undefined && branchIdNew !== prevBranchId.current) {
      localStorage.setItem('branchId', branchIdNew);
      window.location.reload();
    }
    prevBranchId.current = branchIdNew;
  }, [branchIdNew]);

  useEffect(() => {
    if (lineUid) {
      setValue('employeeId', employeeId);
      setValue('branchId', branchId ? Number(branchId) : undefined);
    }
  }, [lineUid, employeeId, branchId, setValue]);

  const onSubmit = () => {
    const payload = {
      lineUid: lineUid,
      branchId: parseInt(branchId),
    };
    onLogout(payload, {
      onSuccess: (res) => {
        openAlert({
          type: 'success',
          message: res?.message,
          model: 'message',
        });

        removeCookies('accessToken');
        localStorage.removeItem('branchId');
        localStorage.removeItem('refreshed');
        setTimeout(() => {
          window.location.href = ROUTES_PATH.ROUTE_MAIN.PATH;
        }, 1000);
      },
      onError: (error) => {
        openAlert({
          type: 'error',
          message: error?.message,
          model: 'message',
        });
      },
    });
  };
  return (
    <Spin spinning={isPendingLogout}>
      <StyledContainer>
        <TextLarge
          text="ออกจากระบบ"
          style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        />
        <RenderForm
          control={control}
          setValue={setValue}
          getValues={getValues}
          forms={FORM_LOGOUT_EMPLOYEE({ branchOption })}
        />
        <ContainerButton center>
          <ButtonTheme useFor="LOGOUT" onClick={handleSubmit(onSubmit)} />
        </ContainerButton>
      </StyledContainer>
    </Spin>
  );
};
